import React from "react";
import { apiPost, apiRequest } from "../../../../utils/api_service";
import { API_URL } from "../../../../constants/api";
import StaffingTable from "../StaffingTable/StaffingTable";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import moment from "moment";
import { IsSectionVisible } from "../../../../utils/helper";
import { SECTIONS } from "../../../../constants/appConstants";
import EditIcon from "@material-ui/icons/Edit";
import CancelIcon from "@material-ui/icons/Cancel";
import IconButton from "@material-ui/core/IconButton";
import SaveIcon from "@material-ui/icons/Save";
import { TextField, Tooltip } from "@material-ui/core";
import { ShowToast, toastType } from "../../../../utils/toast-service";
class StaffingReportWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      StaffingData: [],
      propertyId: localStorage.getItem("selectedPropertyId"),
      startDate: localStorage.getItem("selectedstartDate"),
      endDate: localStorage.getItem("selectedendDate"),
      editFields: false,
      BudgetedHeadCount: ""
    };
  }

  componentDidMount() {
    const { propertyId, startDate, endDate } = this.state;
    this.GetForceStaffingDataByDate(propertyId, startDate, endDate);
  }
  componentWillReceiveProps(newProps) {
    const { propertyId, startDate, endDate } = this.props;
    if (
      newProps.propertyId != propertyId ||
      newProps.startDate != startDate ||
      newProps.endDate != endDate
    ) {
      this.GetForceStaffingDataByDate(
        newProps.propertyId,
        newProps.startDate,
        newProps.endDate
      );
    }
  }

  /** force staffing data by date */
  GetForceStaffingDataByDate = (propertyId, startDate, endDate) => {
    const params = {
      propertyId: propertyId,
      startDate: startDate,
      endDate: endDate
    };

    apiRequest({
      url: API_URL.StaffingSummary.GetStaffingSummaryByDate,
      params
    }).then(({ data: StaffingSummary }) => {
      this.setState({
        StaffingData: StaffingSummary,
        propertyId: propertyId,
        startDate: startDate,
        endDate: endDate
      });
    });
  };

  /** page reload */
  reloadPage = () => {
    const { propertyId, startDate, endDate } = this.props;
    this.GetForceStaffingDataByDate(propertyId, startDate, endDate);
  };

  /** update budgeted head count values */
  UpdateBudgetedHeadCount = () => {
    const { propertyId, startDate, endDate } = this.props;
    const { BudgetedHeadCount } = this.state;
    if (BudgetedHeadCount == "") {
      ShowToast("Please enter Budgeted Head Count", toastType.ERROR, 5000, 200);
      return false;
    }

    const postBody = {
      propertyId: propertyId,
      sectionDetailId: 7,
      attributeValue: BudgetedHeadCount,
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).format("YYYY-MM-DD")
    };

    apiPost({
      url: API_URL.datacenter.UpdateDataCenterAttribute,
      params: [],
      postBody: postBody
    }).then(() => {
      this.setState({ editFields: false });
      this.GetForceStaffingDataByDate(propertyId, startDate, endDate);
      ShowToast("Record updated successfully.", toastType.SUCCESS, 5000, 200);
    });
  };

  render() {
    const {
      StaffingData,
      editFields,
      propertyId,
      startDate,
      endDate
    } = this.state;
    const STAFFING_SUMMARY = IsSectionVisible(
      SECTIONS.STAFFING,
      SECTIONS.STAFFING_SUMMARY
    );
    const CURRENT_STAFFING_TABLE = IsSectionVisible(
      SECTIONS.STAFFING,
      SECTIONS.CURRENT_STAFFING_TABLE
    );

    const BUDGETED_HEAD_COUNT_EDIT = IsSectionVisible(
      SECTIONS.STAFFING,
      SECTIONS.BUDGETED_HEAD_COUNT_EDIT
    );

    return (
      <Grid container>
        {STAFFING_SUMMARY && (
          <Grid item className={"staffing-widget-row"} xs={12}>
            <Grid container>
              {(StaffingData || []).map((item, index) => (
                <Grid item xs={12} md={4} key={"StaffingData" + index}>
                  <Box ml={1} mr={1} className={"staffing-report-widget-div"}>
                    <div className={"w-75 staffing-report-widget-title"}>
                      {item.attributeName}{" "}
                      {item.attributeName == "Budgeted Head Count" ? (
                        editFields ? (
                          <>
                            <Tooltip title={"Save"}>
                              <IconButton size={"small"}>
                                <SaveIcon
                                  style={{
                                    fontSize: "15px",
                                    cursor: "pointer"
                                  }}
                                  onClick={this.UpdateBudgetedHeadCount}
                                />
                              </IconButton>
                            </Tooltip>{" "}
                            <Tooltip title={"Cancel"}>
                              <IconButton size={"small"}>
                                <CancelIcon
                                  style={{
                                    fontSize: "15px",
                                    cursor: "pointer"
                                  }}
                                  onClick={() => {
                                    this.setState({ editFields: false });
                                  }}
                                />
                              </IconButton>
                            </Tooltip>
                          </>
                        ) : (
                          <>
                            {propertyId.split(",").length == 1 ? (
                              BUDGETED_HEAD_COUNT_EDIT ? (
                                <Tooltip title={"Edit"}>
                                  <IconButton size={"small"}>
                                    <EditIcon
                                      style={{
                                        fontSize: "15px",
                                        cursor: "pointer"
                                      }}
                                      onClick={() => {
                                        this.setState({ editFields: true });
                                      }}
                                    />
                                  </IconButton>
                                </Tooltip>
                              ) : null
                            ) : null}
                          </>
                        )
                      ) : null}
                    </div>
                    {editFields &&
                    item.attributeName == "Budgeted Head Count" ? (
                      <div className={"w-25 staffing-report-widget-count"}>
                        <TextField
                          id={"standard-basic"}
                          label={""}
                          size={"small"}
                          style={{ width: "50px" }}
                          onBlur={e => {
                            this.setState({
                              BudgetedHeadCount: e.target.value
                            });
                          }}
                        />
                      </div>
                    ) : (
                      <div className={"w-25 staffing-report-widget-count"}>
                        {" "}
                        {item.attributeValue}{" "}
                        {item.dataFormat == "PercentDecimal" &&
                        item.attributeValue != ""
                          ? "%"
                          : null}
                      </div>
                    )}
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        )}
        {CURRENT_STAFFING_TABLE && (
          <Grid item xs={12}>
            <div className={"staffing-table-row"}>
              <StaffingTable
                startDate={startDate}
                endDate={endDate}
                propertyId={propertyId}
                onUpdate={this.reloadPage}
              />
            </div>
          </Grid>
        )}
      </Grid>
    );
  }
}
export default StaffingReportWidget;
